import { createApp } from 'vue'
import App from './App.vue'
import 'ant-design-vue/dist/antd.css';
import Antd from "ant-design-vue";
// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// console.info("vconsole-info-测试")

createApp(App).use(Antd).mount('#app')
